import { APP_SETTINGS } from '../config/appSettings'

export const PROCESSING_CANDIDATES = ['thinking-bloom', 'diagonal-resolve', 'cognitive-resolve'] as const
export type ProcessingCandidate = typeof PROCESSING_CANDIDATES[number]

const activeCandidate = PROCESSING_CANDIDATES.find(
  (candidate) => candidate === APP_SETTINGS.motion.processing.activeCandidate,
) ?? 'thinking-bloom'

/** Decorative within a labelled status/control; all processing actions share this mark. */
export function ProcessingIndicator({ candidate = activeCandidate }: { candidate?: ProcessingCandidate }) {
  return <span className="processing-indicator" data-processing-candidate={candidate} aria-hidden="true">
    {Array.from({ length: 16 }, (_, index) => <i key={index} />)}
  </span>
}
